import moment from "moment";
import { range } from "lodash-es";
import { getDaysInMonth } from "date-fns";
const MONTHS = range(0, 12).map(month => ({
  month: moment().month(month).format("MMM").toUpperCase(),
  number: month
}));
function isValidInteger(value) {
  // eslint-disable-next-line no-param-reassign
  if (typeof value === "string") value = Number(value);
  return Number.isInteger(value);
}
function inferMonth(string, date) {
  if (string === undefined) return date.getMonth();
  if (isValidInteger(string)) {
    const month = Number(string) - 1;
    if (month < 0 || month > 11) return date.getMonth();
    return month;
  }
  // eslint-disable-next-line no-param-reassign
  string = string.substring(0, 3).toUpperCase();
  const [month] = MONTHS.filter(({
    month
  }) => month.startsWith(string));
  if (month === undefined) return date.getMonth();
  return month.number;
}
function inferDay(string, date) {
  if (string === undefined) return date.getDate();
  const day = Number(string);
  if (!isValidInteger(day) || day < 1 || day > getDaysInMonth(date)) {
    return date.getDate();
  }
  return day;
}
function inferYear(string, date) {
  if (string === undefined) return date.getFullYear();
  const digits = string.trim().length;
  const year = Number(string);
  if (!isValidInteger(year) || year < 0) {
    return date.getFullYear();
  }
  switch (digits) {
    case 2:
      if (year < 50) {
        return 2000 + year;
      }
      return 1900 + year;
    case 4:
      return year;
    default:
      return date.getFullYear();
  }
}
function inferMinutes(string, date) {
  if (string === undefined) return date.getMinutes();
  const minutes = Number(string);
  if (!isValidInteger(minutes) || minutes < 0 || minutes > 60) {
    return date.getMinutes();
  }
  return minutes;
}
function inferHours(string, isPm, date) {
  if (string === undefined) return date.getHours();
  const hours = Number(string);
  if (!isValidInteger(hours) || hours < 0 || hours > 23) {
    return date.getHours();
  }
  if (!isPm && hours === 12) return 0;
  return isPm && hours < 12 ? hours + 12 : hours;
}
function isPm(string, hours) {
  // eslint-disable-next-line no-param-reassign
  string = (string || "").toUpperCase();
  if (string === "PM" || string === "P") return true;
  if (string === "AM" || string === "A") return false;
  if (isValidInteger(hours)) {
    const hoursNumber = Number(hours);
    if (hoursNumber >= 1 && hoursNumber <= 4) return true;
  }
  return false;
}
function getDateFromOnlyNumber(value) {
  let dateFormat = /^(\d{1,2})[\ ]*(\d{1,2})[\ ]*(\d{4}|\d{1,2})*$/i;
  if (value.length === 2) {
    dateFormat = /^(\d{2})()()$/;
  }
  return value.match(dateFormat);
}
function getDateFromMonthStr(value) {
  const dateFormat = /^([a-z]+)[\ ]*([1][0-9]|2[0-9]|3[01]|0?[1-9])*[\,*\ +]*(\d{4}|\d{2})*$/i;
  return value.match(dateFormat);
}
function getDateFromGeneral(value) {
  const dateFormat = /^([1][0-9]|2[0-9]|3[01]|0?[1-9]+)[\:](0?[1-9]|1[012])[\ ]*([ap]+m*)*$/i;
  return value.match(dateFormat);
}
function getDate(value) {
  const values = getDateFromOnlyNumber(value) || getDateFromGeneral(value) || getDateFromMonthStr(value);
  return values ? values.slice(1, 4) : [];
}
function getTimeFromSimple(value) {
  let dateFormat = /^(\d{1})(\d{0,2})([ap]+m*)*$/i;
  if (/\d{4}[\ ]*[ap]*/i.test(value)) {
    dateFormat = /^(\d{2})(\d{1,2})[\ ]*([ap]+m*)*$/i;
  } else if (/^\d{2}$/.test(value)) {
    dateFormat = /^(\d{2})()()$/i;
  }
  return value.match(dateFormat);
}
function getTimeFromGeneral(value) {
  const dateFormat = /^(0?[1-9]|[1][0-9]|2[0-3]+)[\:](0?[1-9]|[0-5]*[0-9]+)[\ ]*([ap]+m*)*$/i;
  return value.match(dateFormat);
}
function getTime(value) {
  const values = getTimeFromSimple(value) || getTimeFromGeneral(value);
  return values ? values.slice(1, 4) : [];
}
export function inferDate(string, date) {
  const [month, day, year] = getDate(string);
  return new Date(inferYear(year, date), inferMonth(month, date), inferDay(day, date), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
export function inferTime(string, date) {
  const [hours, minutes, amPm] = getTime(string);
  return {
    hours: inferHours(hours, isPm(amPm, hours), date),
    minutes: inferMinutes(minutes, date)
  };
}
export function toMinutes({
  hours,
  minutes
}) {
  return hours % 24 * 60 + minutes;
}
export function isValidDateFormat(string) {
  const [month, day] = getDate(string);
  if (!month || !day) return false;
  if (isValidInteger(month)) {
    const monthNum = Number(month);
    return monthNum >= 1 && monthNum <= 12;
  }
  if (month.length < 3) return false;
  return true;
}
//# sourceMappingURL=parseDate.js.map